// extracted by mini-css-extract-plugin
export var option = "_am-0";
export var optionCard = "_am-f";
export var optionContent = "_am-g";
export var optionIcon = "_am-i";
export var optionIconBox = "_am-h";
export var optionLabel = "_am-j";
export var optionPill = "_am-m";
export var optionPillBadge = "_am-p";
export var optionPillIcon = "_am-n";
export var optionPillLabel = "_am-o";
export var optionRadio = "_am-k";
export var optionRadioInner = "_am-l";
export var optionReveal = "_am-2";
export var optionRevealDelay0 = "_am-3";
export var optionRevealDelay1 = "_am-4";
export var optionRevealDelay10 = "_am-d";
export var optionRevealDelay11 = "_am-e";
export var optionRevealDelay2 = "_am-5";
export var optionRevealDelay3 = "_am-6";
export var optionRevealDelay4 = "_am-7";
export var optionRevealDelay5 = "_am-8";
export var optionRevealDelay6 = "_am-9";
export var optionRevealDelay7 = "_am-a";
export var optionRevealDelay8 = "_am-b";
export var optionRevealDelay9 = "_am-c";
export var optionSelected = "_am-1";